import React from 'react';
import * as S from './styled';
export const ProgressBar = ({ value, max = 100, height = 2, barColor }) => (React.createElement(S.Container, { "$height": height },
    React.createElement(S.Bar, { "data-testid": "ProgressBar.Bar", "$color": barColor, style: { width: `${(value / max) * 100}%` } })));
